"use client"

import axios from "axios";
import { usePathname, useSearchParams } from "next/navigation";
import { ReactNode, useEffect } from "react";

// Helper to get cookie value on client
function getCookie(name: string): string | null {
  if (typeof document === "undefined") return null;
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop()?.split(';').shift() || null;
  return null;
}

// Note: user_id prop is kept for backwards compatibility but we read from cookie on client
export default function VexubTracker({children,ip,device,token,user_agent,user_id: _serverUserId} : {children : ReactNode,ip : string,device : string,token : string,user_agent : string,user_id : string}) {
    useEffect(() => {
        const sendTrackerData = () => {
            const params = new URLSearchParams();
            params.append("ip", ip);
            params.append("device", device);
            params.append("site_url", window.location.href);
            params.append("user_agent",navigator.userAgent)
            params.append("token", token);
            params.append("referer",document.referrer || "")
            // Read user_id from cookie on client to avoid hydration mismatch
            const clientUserId = getCookie("user_id") || _serverUserId;
            if (clientUserId) {
                params.append("user_id", clientUserId);
            }

            axios.post("/api/track/st", params)
        }

        setTimeout(() => {
            sendTrackerData()
        },100)

    },[])

    return (
        <>{children}</>
    )
}